module.exports = __webpack_public_path__ + "static/media/subtitle_star.ed9e80ca.svg";